module.exports = __webpack_public_path__ + "static/Banner-3a9cd31ddb466d948e56c448302a7e81.png";